import { TableHead, TableHeader, TableRow } from '../ui/table';
import SortIcon from './SortIcon';

export interface HeaderDefinition {
  key: string;
  label: string;
  sortable?: boolean;
  className?: string;
}

interface Props {
  headers: HeaderDefinition[];
  sortColumn: string;
  setSortColumn: React.Dispatch<React.SetStateAction<string>>;
  sortDirection: 'ASC' | 'DESC';
  setSortDirection: React.Dispatch<React.SetStateAction<'ASC' | 'DESC'>>;
  onSortChange?: () => void;
}

function DataTableHeader({
  headers,
  sortColumn,
  setSortColumn,
  sortDirection,
  setSortDirection,
  onSortChange
}: Props) {
  const handleSort = (header: HeaderDefinition) => {
    if (header.sortable) {
      if (sortColumn === header.key) {
        setSortDirection((prev) => (prev === 'ASC' ? 'DESC' : 'ASC'));
      } else {
        setSortDirection('ASC');
      }

      setSortColumn(header.key);

      if (onSortChange) {
        onSortChange();
      }
    }
  };

  return (
    <TableHeader>
      <TableRow className='dark:bg-gray-800 dark:hover:bg-gray-800'>
        {headers.map((header) => (
          <TableHead
            key={header.key}
            className={`cursor-pointer dark:text-gray-300 ${header.className || ''}`}
            onClick={() => handleSort(header)}
          >
            {header.label}
            {header.sortable && (
              <SortIcon
                columnKey={header.key}
                selectedColumn={sortColumn}
                sortDirection={sortDirection}
              />
            )}
          </TableHead>
        ))}
      </TableRow>
    </TableHeader>
  );
}

export default DataTableHeader;
